<template>
  <div
    class="flight-box-column"
    :class="parentClass"
  >
    <FlightBoxTitle
      :primary="primary"
      :type="type"
    />
    <CharterFlightLeg
      v-for="(leg, index) in segments.slice(0, expanded ? undefined : 1)"
      :key="`fa_${index}`"
      :flight="leg"
      v-bind="getFlightLegProps(index)"
    >
      <template #flight-stops>
        <FlightStops
          :primary="index === 0 && primary"
          :stops="stops"
          :duration="duration"
          :expanded="expanded"
          :flights-collapsed="flightsCollapsed"
          @expand="$emit('expand')"
          @collapse="$emit('collapse')"
        />
      </template>
      <template #leg-info>
        <div class="flex justify-start items-center">
          <AirlineLabel :carrier-code="leg.carrierCode" />
          <CharterFlightLuggage
            v-if="showLuggage && (!expanded || segments.length === 1)"
            class="ml-6"
            :luggage="luggage"
          />
        </div>
        <AirlineLuggagePolicy
          v-if="!allLegsSameCarrier"
          :carrier-code="leg.carrierCode"
          :luggage-policies="luggagePolicies"
        />
      </template>
    </CharterFlightLeg>
    <CharterFlightLuggage
      v-if="showLuggage && expanded && segments.length !== 1"
      class="mt-2"
      :luggage="luggage"
    />
    <AirlineLuggagePolicy
      v-if="allLegsSameCarrier"
      :carrier-code="firstLeg.carrierCode"
      :luggage-policies="luggagePolicies"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'CharterItineraryFlightRow',

  props: {
    type: {
      type: String,
      default: 'departure',
    },

    parentClass: {
      type: Object,
      default: () => {},
    },

    primary: {
      type: Boolean,
      default: false,
    },

    flightInfo: {
      type: Object,
      default: () => {},
    },

    flightsCollapsed: {
      type: Boolean,
      default: false,
    },

    showLuggage: {
      type: Boolean,
      default: false,
    },

    luggage: {
      type: Boolean,
      default: false,
    },

    expanded: {
      type: Boolean,
      default: false,
    },

    luggagePolicies: {
      type: Array,
      default: null,
    },
  },

  emits: ['expand', 'collapse'],

  computed: {
    duration () {
      return this.flightInfo?.duration || this.firstLeg?.duration
    },

    segments () {
      return (this.flightInfo?.segments || [])
    },

    stops () {
      return this.segments.length
    },

    firstLeg () {
      return this.segments[0]
    },

    arrival () {
      if (this.expanded) {
        return null
      }
      return this.segments.slice(-1)[0]?.arrival
    },

    allLegsSameCarrier () {
      return this.segments.map(segment => segment.carrierCode).every((val, _, arr) => val === arr[0])
    },
  },

  methods: {
    shouldShowLuggageExpanded (index) {
      return this.showLuggage &&
        index === this.segments.slice(1).length - 1
    },

    getFlightLegProps (index) {
      const first = index === 0
      const baseProps = {
        luggage: this.luggage,
      }
      if (first) {
        return {
          ...baseProps,
          duration: this.duration,
          stops: this.stops,
          type: this.type,
          primary: this.primary,
          expanded: this.expanded,
          flightsCollapsed: this.flightsCollapsed,
          arrival: this.arrival,
          showLuggage: !this.expanded,
        }
      }
      return {
        ...baseProps,
        showLuggage: this.shouldShowLuggageExpanded(index),
      }
    },
  },
})
</script>
